import { create } from "zustand";
import { persist } from "zustand/middleware";

export type ThemeMode = "light" | "dark" | "orange";

export interface ThemeState {
  theme: ThemeMode;
  setTheme: (theme: ThemeMode) => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      theme: "orange", // Default theme

      setTheme: (theme) => {
        // Update the document class for theme switching
        const root = document.documentElement;
        root.classList.remove("theme-light", "theme-dark", "theme-orange");
        root.classList.add(`theme-${theme}`);
        set({ theme });
      },
    }),
    {
      name: "t2c-theme",
      onRehydrateStorage: () => (state) => {
        // Apply theme on rehydration
        if (state) {
          const root = document.documentElement;
          root.classList.remove("theme-light", "theme-dark", "theme-orange");
          root.classList.add(`theme-${state.theme}`);
        }
      },
    },
  ),
);

// Initialize theme on app load
export function initializeTheme() {
  const state = useThemeStore.getState();
  const root = document.documentElement;
  root.classList.remove("theme-light", "theme-dark", "theme-orange");
  root.classList.add(`theme-${state.theme}`);
}
